import { useState } from "react";
import AsignacionesEditor, { asignacionesDe } from "./AsignacionesEditor";
import Icon from "../Icon";
import DatePicker from "./DatePicker";
import { Avatar, ModalFt } from "../Atoms";
import { PJ_ESTADOS, PJ_PRIOS, PJ_NODOS, PJ_ROLES } from "../../constants";
import Campo from "./Campo";

// Un paso del proyecto. Es a la vez la tarea y el nodo del diagrama de flujo:
// los tipos que no son 'tarea' (inicio, fin, condicional, hito) no son trabajo,
// asi que se les ocultan los campos de trabajo en lugar de dejarlos ahi sin
// efecto (la base de datos los rechaza con tasks_nodo_control_chk).
export default function PasoForm({ paso, users = [], miembros = [], teams = [], inS, lbS, onSave, onClose }) {
  const ed = !!paso;
  const [f, setF] = useState({
    title:       paso?.title || "",
    description: paso?.description || "",
    kind:        paso?.kind || "tarea",
    tipo:        paso?.tipo || "",
    status:      paso?.status || "Pendiente",
    priority:    paso?.priority || "Media",
    start_date:  paso?.start_date || "",
    due_date:    paso?.due_date || "",
    estimacion_h: paso?.estimacion_min ? paso.estimacion_min / 60 : "",
    condicion:   paso?.condicion || "",
    team_id:     paso?.team_id || "",
  });
  const [asig, setAsig] = useState(() => asignacionesDe(paso));

  const set = (k, v) => setF(p => ({ ...p, [k]: v }));
  const esTrabajo = f.kind === "tarea";

  const fechasAlReves = f.start_date && f.due_date && f.due_date < f.start_date;
  const valido = f.title.trim() && !fechasAlReves;

  const guardar = () => {
    if (!valido) return;
    const est = parseFloat(f.estimacion_h);
    onSave({
      title: f.title.trim(),
      description: f.description.trim() || null,
      kind: f.kind,
      status: f.status,
      start_date: f.start_date || null,
      due_date: f.due_date || null,
      team_id: f.team_id || null,
      ...(esTrabajo ? {
        tipo: f.tipo.trim() || null,
        priority: f.priority,
        estimacion_min: isNaN(est) ? null : Math.round(est * 60),
        encargados:    asig.encargado,
        responsables:  asig.responsable,
        participantes: asig.participante,
      } : {}),
      ...(f.kind === "condicional" ? { condicion: f.condicion.trim() || null } : {}),
    });
  };

  return (
    <div>
      <div data-titulo="1" style={{ fontWeight: 800, fontSize: 16, marginBottom: 4, color: "var(--text)" }}>
        {ed ? "Editar paso" : "Nuevo paso"}
      </div>
      <div style={{ fontSize: 11.5, color: "var(--text3)", marginBottom: 15, lineHeight: 1.5 }}>
        Un paso es una tarea con sus fechas, quien la desarrolla y a quien pedir ayuda.
      </div>

      <Campo><label style={lbS}>Que clase de nodo es</label>
      <div style={{ display: "flex", gap: 5, flexWrap: "wrap", marginBottom: 12 }}>
        {PJ_NODOS.map(n => (
          <button key={n.key} className="btn" onClick={() => set("kind", n.key)}
            style={{ padding: "6px 10px", borderRadius: 8, cursor: "pointer", fontSize: 11.5,
              fontFamily: "var(--font)", display: "flex", alignItems: "center", gap: 5,
              fontWeight: f.kind === n.key ? 700 : 500,
              border: `1px solid ${f.kind === n.key ? "var(--accent)" : "var(--border)"}`,
              background: f.kind === n.key ? "var(--accent-bg)" : "var(--surface)",
              color: f.kind === n.key ? "var(--accent)" : "var(--text2)" }}>
            <Icon name={n.icon} size={11} color={f.kind === n.key ? "var(--accent)" : "var(--text3)"} />
            {n.label}
          </button>
        ))}
      </div></Campo>
      {!esTrabajo && (
        <div style={{ fontSize: 11, color: "var(--text3)", background: "var(--surface2)",
          padding: "7px 10px", borderRadius: 8, marginBottom: 12, lineHeight: 1.5 }}>
          Los nodos de control ordenan el flujo pero no son trabajo: no llevan prioridad,
          estimacion ni progreso, y no cuentan para el avance del proyecto.
        </div>
      )}

      <Campo><label style={lbS}>Titulo</label>
      <input style={inS} value={f.title} autoFocus onChange={e => set("title", e.target.value)}
        placeholder={f.kind === "condicional" ? "Revision del cliente" : "Preparar el entorno"} /></Campo>

      <Campo><label style={lbS}>Descripcion</label>
      <textarea style={{ ...inS, minHeight: 58, resize: "vertical" }} value={f.description}
        onChange={e => set("description", e.target.value)}
        placeholder="Detalles, criterios de aceptacion..." /></Campo>

      {f.kind === "condicional" && (
        <>
          <Campo><label style={lbS}>La pregunta que se hace este nodo</label>
          <input style={inS} value={f.condicion} onChange={e => set("condicion", e.target.value)}
            placeholder="¿Lo aprueba el cliente?" /></Campo>
          <div style={{ fontSize: 10.5, color: "var(--text3)", marginTop: -6, marginBottom: 11 }}>
            Las respuestas (Si / No) se ponen en las conexiones que salgan de aqui.
          </div>
        </>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <div>
          <Campo><label style={lbS}>Fecha de inicio</label>
          <DatePicker value={f.start_date} nombre="Fecha de inicio"
            placeholder="Sin fecha" margenInferior={0}
            onChange={v => set("start_date", v)} /></Campo>
        </div>
        <div>
          <Campo><label style={lbS}>Fecha de fin</label>
          <DatePicker value={f.due_date} nombre="Fecha de fin"
            placeholder="Sin fecha" margenInferior={0} invalido={fechasAlReves}
            refDate={f.start_date}
            onChange={v => set("due_date", v)} /></Campo>
        </div>
      </div>
      {fechasAlReves && (
        <div style={{ fontSize: 11, color: "var(--red-text)", marginTop: -6, marginBottom: 10 }}>
          La fecha de fin es anterior a la de inicio.
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: esTrabajo ? "1fr 1fr" : "1fr", gap: 10 }}>
        <div>
          <Campo><label style={lbS}>Estado</label>
          <select style={{ ...inS, cursor: "pointer" }} value={f.status}
            onChange={e => set("status", e.target.value)}>
            {PJ_ESTADOS.map(s => <option key={s} value={s}>{s}</option>)}
          </select></Campo>
        </div>
        {esTrabajo && (
          <div>
            <Campo><label style={lbS}>Prioridad</label>
            <select style={{ ...inS, cursor: "pointer" }} value={f.priority}
              onChange={e => set("priority", e.target.value)}>
              {PJ_PRIOS.map(p => <option key={p} value={p}>{p}</option>)}
            </select></Campo>
          </div>
        )}
      </div>

      {esTrabajo && (
        <>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <Campo><label style={lbS}>Tipo de trabajo</label>
              <input style={inS} value={f.tipo} onChange={e => set("tipo", e.target.value)}
                placeholder="Desarrollo, reunion..." /></Campo>
            </div>
            <div>
              <Campo><label style={lbS}>Estimacion (horas)</label>
              <input type="number" min={0} step={0.5} style={inS} value={f.estimacion_h}
                onChange={e => set("estimacion_h", e.target.value)} placeholder="sin estimar" /></Campo>
            </div>
          </div>
          <div style={{ fontSize: 10.5, color: "var(--text3)", marginTop: -6, marginBottom: 12,
            lineHeight: 1.5 }}>
            La estimacion es lo que permite contrastar lo previsto con las horas reales del
            cuaderno. Sin ella, el avance del paso se calcula solo por su estado.
          </div>

          <Campo><label style={lbS}>Quien lo hace y a quien preguntar</label>
          <div style={{ marginBottom: 13 }}>
            <AsignacionesEditor valor={asig} onChange={setAsig}
              users={users} miembros={miembros} />
          </div></Campo>
        </>
      )}

      <ModalFt onClose={onClose} onSave={guardar} disabled={!valido}
        label={ed ? "Guardar" : "Crear paso"} />
    </div>
  );
}
